import React from 'react';
import UsersForm from './UsersForm';

const EditUserPage = () => <UsersForm formType="edit" />;

export default EditUserPage;
